import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-ink text-white/[.55] pt-14 pb-8 text-[0.9rem]">
      <div className="container mx-auto max-w-[1140px] px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="font-figtree font-bold text-[1.25rem] text-white inline-flex items-center gap-[0.55rem]">
              <img
                src="/assets/onedpdp-logo.png"
                alt=""
                width="32"
                height="32"
                className="h-8 w-8 object-cover rounded bg-white"
              />
              One<span className="text-gold">DPDP</span>
            </div>
            <p className="mt-2 max-w-[22rem]">
              AI-powered compliance platform for India's Digital Personal Data
              Protection Act — assessments, risk, breach response and policy in
              one place.
            </p>
          </div>

          <div>
            <div className="text-[0.72rem] tracking-[0.1em] uppercase text-white/35 mb-[0.85rem]">
              Platform
            </div>
            <div className="flex flex-col gap-2">
              <a
                href="#platform"
                className="hover:text-teal-bright transition-colors"
              >
                Platform
              </a>
              <Link
                to="/consent-management"
                className="hover:text-teal-bright transition-colors"
              >
                Consent Management
              </Link>
              <a
                href="#how"
                className="hover:text-teal-bright transition-colors"
              >
                How it works
              </a>
              <a
                href="#discovery"
                className="hover:text-teal-bright transition-colors"
              >
                Discovery
              </a>
              <a
                href="#ai"
                className="hover:text-teal-bright transition-colors"
              >
                AI &amp; Savings
              </a>
              <a
                href="#policies"
                className="hover:text-teal-bright transition-colors"
              >
                Policy Store
              </a>
            </div>
          </div>

          <div>
            <div className="text-[0.72rem] tracking-[0.1em] uppercase text-white/35 mb-[0.85rem]">
              Contact
            </div>
            <div className="flex flex-col gap-2">
              <a
                href="mailto:sales@onedpdp.com"
                className="hover:text-teal-bright transition-colors"
              >
                sales@onedpdp.com
              </a>
              <a
                href="#contact"
                className="hover:text-teal-bright transition-colors"
              >
                Request a demo
              </a>
            </div>
          </div>
        </div>

        <hr className="border-white/[.08] my-9" />

        <div className="flex flex-col md:flex-row justify-between gap-2">
          <span>&copy; 2026 OneDPDP. All rights reserved.</span>
          <span>
            <a href="#" className="hover:text-teal-bright transition-colors">
              Privacy Policy
            </a>
            &nbsp;·&nbsp;
            <a href="#" className="hover:text-teal-bright transition-colors">
              Terms of Service
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}
